export default {"src":"/_next/static/media/right-hand.3358f734.svg","height":150,"width":241,"blurWidth":0,"blurHeight":0};